module.exports = __webpack_public_path__ + "static/media/circus.30a33492.mp3";